<template>
  <section>
    <v-container
      v-if="value"
      style="max-width:1024px"
      class="d-block d-md-none"
      id="info-box-mobile"
    >
      <v-row justify="center" align="center">
        <v-col cols="6" class="text-center">
          <v-img :src="tile.logo" style="width:100%;height:auto"></v-img>
        </v-col>
        <v-col cols="9" class="text-center">
          <h5 class="secondary--text tile-title">{{tile.title}}</h5>
          <p class="info-tile-text caption mb-0" v-html="tile.description"></p>
          <div class="mt-4">
            <v-btn
              v-if="tile.link.url"
              small
              :to="tile.link.url"
              color="secondary"
            >{{tile.link.text}}</v-btn>
            <v-btn v-else-if="tile.link.text" small outlined disabled>{{tile.link.text}}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-if="value"
      style="max-width:1024px"
      class="d-none d-md-block"
      id="info-box-desktop"
    >
      <v-row justify="center" align="center">
        <v-col cols="4" class="text-center">
          <v-img :src="tile.logo" style="width:100%;height:auto"></v-img>
        </v-col>
        <v-col cols="8" class="text-left">
          <h3 class="secondary--text tile-title">{{tile.title}}</h3>
          <p class="info-tile-text" v-html="tile.description"></p>
          <div class="mt-4">
            <v-btn v-if="tile.link.url" :to="tile.link.url" color="secondary">{{tile.link.text}}</v-btn>
            <v-btn v-else-if="tile.link.text" outlined disabled>{{tile.link.text}}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "InfoBox",
  props: ["value"],
  computed: {
    tile() {
      return this.value;
    }
  }
};
</script>

<style>
.tile-title {
  font-family: "Montserrat", sans-serif;
}
.info-tile-text {
  padding-top: 0px;
}
#info-box-desktop {
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>